require('./classCodePropsFilter.js');
const ClassCodeComponent = {
    templateUrl: '/formViewer/component/classCode/classCode.tpl.html',
    controller: 'classCodeController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<',
        effectiveDate: '<?',
        onSelect: '&?'
    }
};

angular.module('umCore')
    .component('uiClassCode', ClassCodeComponent);
